import { useQueryClient } from 'react-query';
import QUERY_CACHE_KEY from '@constants/QueryCacheKey';
import useApiMutation from './useApiMutation';

function useUpdateMeMutation(options) {
  const queryClient = useQueryClient();

  return useApiMutation('patch', `/v1/me`, {
    ...options,
    onSuccess: (res, ...rest) => {
      queryClient.setQueryData(QUERY_CACHE_KEY.me(), res.data);

      if ('function' === typeof options?.onSuccess) {
        options.onSuccess(res, ...rest);
      }
    },
  });
}

export default useUpdateMeMutation;
